export const setAuthToken = (token) => ({
    type: "SET_AUTH_TOKEN",
    payload: token,
});